const pride = [
    {
        alias: "pride",
        title: "CBC Pride",
        url: "/pride/topic/Collections/Spotlight%20on%20Pride",
        image: "https://www.cbc.ca/radio-content/assets/banners/CBCPride_banner.jpg",
        nestedPath: true,
        nestedUrl: "/pride/topic/collections/spotlight%20on%20pride",
    },
];

export default pride;
